// Fair Weather — theme JS

// Newsletter popup: open once per visitor, dismiss persists
(function() {
  var popup = document.getElementById('newsletter-popup');
  if (!popup) return;
  var seen = false;
  try { seen = localStorage.getItem('fw_popup_seen') === '1'; } catch (e) {}
  if (!seen) {
    setTimeout(function() { popup.classList.add('active'); }, 1500);
  }
  popup.addEventListener('click', function(e) {
    if (e.target === popup) close();
  });
  var closeBtn = popup.querySelector('.popup-close');
  if (closeBtn) closeBtn.addEventListener('click', close);
  function close() {
    popup.classList.remove('active');
    try { localStorage.setItem('fw_popup_seen', '1'); } catch (e) {}
  }
})();

// Live London weather widget — Open-Meteo (no API key required)
(function() {
  var el = document.getElementById('weather');
  if (!el) return;
  var loc = (el.dataset.location || 'London,GB').split(',')[0];
  // London coords by default
  var lat = 51.5074, lon = -0.1278;
  var url = 'https://api.open-meteo.com/v1/forecast?latitude=' + lat +
            '&longitude=' + lon +
            '&current=temperature_2m,weather_code,wind_speed_10m,wind_direction_10m' +
            '&wind_speed_unit=kmh&timezone=Europe/London';
  var codes = {
    0: 'Clear', 1: 'Mainly clear', 2: 'Partly cloudy', 3: 'Overcast',
    45: 'Foggy', 48: 'Foggy', 51: 'Light drizzle', 53: 'Drizzle', 55: 'Heavy drizzle',
    61: 'Light rain', 63: 'Rain', 65: 'Heavy rain',
    71: 'Light snow', 73: 'Snow', 75: 'Heavy snow',
    80: 'Showers', 81: 'Showers', 82: 'Heavy showers',
    95: 'Thunderstorm'
  };
  function dirToCardinal(d) {
    var dirs = ['N','NE','E','SE','S','SW','W','NW'];
    return dirs[Math.round(((d % 360) / 45)) % 8];
  }
  fetch(url).then(function(r) { return r.json(); }).then(function(data) {
    if (!data || !data.current) return;
    var c = data.current;
    var temp = Math.round(c.temperature_2m);
    var cond = codes[c.weather_code] || 'Clear';
    var dir = dirToCardinal(c.wind_direction_10m);
    var wind = Math.round(c.wind_speed_10m);
    el.textContent = temp + '°C, ' + cond + ', ' + dir + ' ' + wind + ' km/h';
  }).catch(function() { /* keep fallback text */ });
})();
